<v-snackbar
    :model-value="isSnackbarShowing"
    @update:model-value="setShowing"
    :timeout="10000"
    :color="color"
    multi-line>
    {{ message }}
    <template v-slot:actions>
        <v-btn color="white" variant="text" @click="setShowing(false)">
            Close
        </v-btn>
    </template>
</v-snackbar>